<canvas #canvas
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (mouseup)="onMouseUp()"
        (mouseout)="onMouseOut()"
        style="border: 1px solid black;"></canvas>
